/* eslint-disable no-console */

import { loadStripe } from '@stripe/stripe-js';
import { stripeAPIKey } from 'reactAppConstants';

const stripePromise = loadStripe(stripeAPIKey).catch((e) => console.error(e));
export default stripePromise;
